import { Text, StyleSheet } from '@react-pdf/renderer';
import { theme } from '../theme';

const style = StyleSheet.create({
  pdfTableCellStyle: {
    padding: '3px',

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: '18%',
    flexWrap: 'wrap',

    textAlign: 'right',
    borderRight: `1px solid ${theme.colors.primaryK1}`,
    height: '100%',
  },
  firstTableCellStyle: {
    flexBasis: '35%',
    textAlign: 'left',
    flexShrink: 1,
  },
  textAlignStyle: {
    textAlign: 'left',
  },
  narrowColumnStyle: {
    flexBasis: '10%',
    flexWrap: 'nowrap',
  },
  accentedStyle: {
    fontWeight: 'bold',
  },
});

export const PdfTableCell: React.FC<{
  isFirstColumn?: boolean;
  isNarrowColumn?: boolean;
  isLeftAligned?: boolean;
  text?: string | number;
  isAccented?: boolean;
}> = ({ isFirstColumn, isNarrowColumn, isLeftAligned, text, isAccented }) => (
  <Text
    style={[
      style.pdfTableCellStyle,
      isFirstColumn ? style.firstTableCellStyle : {},
      isNarrowColumn ? style.narrowColumnStyle : {},
      isLeftAligned ? style.textAlignStyle : {},
      isAccented ? style.accentedStyle : {},
    ]}>
    {text?.toString()}
  </Text>
);
